import { Injectable } from "@angular/core";
import { clearGuestIdentityBrowserState } from "./guest-identity-storage";

@Injectable({ providedIn: "root" })
export class AuthenticatedSessionStateService {
  private readonly localStorageKeys = [
    "chat",
    "chatPlayer",
    "chatSettingsCanManage",
    "chatSettingsSourceChatId",
    "event",
    "eventForPlayerDetail",
    "historyTargetEventId",
    "nearByLocations",
    "openPlayerDetailForEventId",
    "openPlayerDetailForPlayerId",
    "openResultDialogForEventId",
    "peiForPlayerDetail",
    "player",
    "returnToPlayerDetailAfterChat",
    "savedEventEdit",
  ];

  private readonly sessionStorageKeys = [
    "eventDetailFocusSection",
    "eventDetailReturnRoute",
    "newPlayspace",
    "openRulebookForEventId",
    "playspaceReturnRoute",
    "returningFromNewPlayspaceForm",
  ];

  public clearAppState(): void {
    this.localStorageKeys.forEach((key) => localStorage.removeItem(key));
    this.sessionStorageKeys.forEach((key) => sessionStorage.removeItem(key));
  }

  public clear(): void {
    this.clearAppState();
    clearGuestIdentityBrowserState();
    this.clearAuth0SpaCache();
  }

  private clearAuth0SpaCache(): void {
    Object.keys(localStorage)
      .filter((key) => key.indexOf("@@auth0spajs@@") === 0)
      .forEach((key) => localStorage.removeItem(key));
  }
}
